// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/relatorios/suasapostas.css
// module id = 1036
// module chunks = 0